import Skeleton from '@mui/material/Skeleton';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';

export const LoadingTableRows = ({
  columnCount,
  rowCount = 5,
}: {
  columnCount: number;
  rowCount?: number;
}) => {
  return Array.from({ length: rowCount }).map((_, rowIndex) => (
    <TableRow key={rowIndex}>
      {Array.from({ length: columnCount }).map((_, colIndex) => (
        <TableCell key={colIndex}>
          <Skeleton variant="text" width={!rowIndex || rowIndex % 2 === 0 ? '100%' : '75%'} />
        </TableCell>
      ))}
    </TableRow>
  ));
};
